import { Dispatch } from 'redux';

import { nuc } from '../../utils';
import { get, remove } from '../api';

// action types
export const FETCH_PROJECTS = 'FETCH_PROJECTS';
export const POLL_PROJECTS_START = 'POLL_PROJECTS_START';
export const POLL_PROJECTS_STOP = 'POLL_PROJECTS_STOP';
export const FETCH_PROJECT_BRANCHES = 'FETCH_PROJECT_BRANCHES';
export const FETCH_PROJECT_REVISIONS = 'FETCH_PROJECT_REVISIONS';
export const UPDATE_PROJECT_SELECTED_BRANCH = 'UPDATE_PROJECT_SELECTED_BRANCH';
export const UPDATE_PROJECT_SELECTED_REVISION = 'UPDATE_PROJECT_SELECTED_REVISION';
export const FETCH_ALL_PROJECTS = 'FETCH_ALL_PROJECTS';
export const DELETE_PROJECTS = 'DELETE_PROJECTS';

const ProjectActions = {
  fetchAll: ({ organizationId, count }: { organizationId: number; count?: number }) => async (dispatch: Dispatch) => {
    dispatch({
      type: `${FETCH_PROJECTS}_PENDING`,
    });
    dispatch({
      type: FETCH_ALL_PROJECTS,
      organizationId,
      count: count ?? 500,
    });
  },

  startPollProjects: (organizationId: number) => ({
    type: POLL_PROJECTS_START,
    payload: organizationId,
  }),
  stopPollProjects: () => ({
    type: POLL_PROJECTS_STOP,
  }),

  delete: (locators: string[]) => {
    return {
      type: DELETE_PROJECTS,
      meta: {
        locators,
      },
      async payload() {
        const deletePromises = locators.map((loc) => remove(`/api/projects/${nuc(loc)}`));
        return Promise.all(deletePromises);
      },
    };
  },
  fetchBranches: (locator) => ({
    type: FETCH_PROJECT_BRANCHES,
    meta: {
      locator,
    },
    payload: async () => get(`/api/projects/${nuc(locator)}`, false, {
      ref_type: 'branch',
    }),
  }),
  fetchRevisions: (locator, branch) => ({
    type: FETCH_PROJECT_REVISIONS,
    meta: {
      locator,
      branch,
    },
    payload: async () => get(`/api/projects/${nuc(locator)}/revisions`, false, {
      count: 100,
      offset: 0,
      'refs[0]': nuc(branch),
      refs_type: 'branch',
      resolved: true,
      //  This ensures that only the locator is returned in the response,
      //  which is the only thing we need from it in the two places this action is used (ie: in the create and edit release groups pages)
      isMinimal: true,
    }),
  }),
};

export default ProjectActions;
